<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav
    class="sidenav"
    [mode]="isDesktop ? 'side' : 'over'"
    [opened]="isDesktop"
    [disableClose]="isDesktop"
    >
    <div class="sidebar">
      <div class="sidebar-top">
        <div class="logo">
          <img ngSrc="assets/logo.svg" alt="LARS logo" i18n-alt="@@Lars_LogoAlt" height="500" width="500"/>
        </div>
        <mat-nav-list id="tour-sidebar-nav" class="p-0">
          <button
            mat-list-item
            class="!px-0 decks-toggle"
            (click)="decksExpanded = !decksExpanded"
            >
            <div class="flex items-center gap-3 px-3 py-2 w-full">
              <mat-icon class="!ml-0">layers</mat-icon>
              <span class="text-white" i18n="@@Layout.Decks">Decks</span>
              <span class="flex-1"></span>
              <mat-icon class="text-sm">
                {{ decksExpanded ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </div>
          </button>

          @if (decksExpanded) {
            @for (deck of deckLinks; track deck) {
              <button
                mat-list-item
                (click)="onNavLinkClick($event, deck.path)"
                [class.selected]="activeDeckLink === deck.path"
                class="!px-0 decks-child"
                >
                <div class="flex items-center gap-3 px-3 py-2 w-full pl-8">
                  <mat-icon class="!ml-0">{{ getIconForPath(deck.path) }}</mat-icon>
                  <span class="text-white">{{ deck.label }}</span>
                </div>
              </button>
            }
          }
          @for (link of links; track link) {
            <button
              mat-list-item
              (click)="onNavLinkClick($event, link.path)"
              [class.selected]="link.isActive"
              [attr.id]="link.path === '/app/faq' ? 'tour-faq-link' : null"
              class="!px-0"
              >
              <div class="flex items-center gap-3 px-3 py-2 w-full">
                <mat-icon class="!ml-0">{{ getIconForPath(link.path) }}</mat-icon>
                <span class="text-white" >{{ link.name }}</span>
              </div>
            </button>
          }
        </mat-nav-list>
      </div>

      <div class="sidebar-bottom">
        <mat-divider></mat-divider>

        <button mat-button class="more-button" disableRipple>
          <mat-icon>menu</mat-icon>
          <span class="mdc-list-item__primary-text" i18n="@@More">More</span>
        </button>

        <button
          id="tour-profile-btn"
          mat-button
          class="secondary-link"
          [class.selected]="isUserProfilePage"
          (click)="navigateToUserProfile()"
          >
          <mat-icon>person</mat-icon>
          <span class="mdc-list-item__primary-text" i18n="@@MyProfile">My Profile</span>
        </button>

        <button
          mat-button
          class="secondary-link"
          (click)="goToSettings()"
          >
          <mat-icon>settings</mat-icon>
          <span class="mdc-list-item__primary-text" i18n="@@Settings">Settings</span>
        </button>

        <button
          mat-button
          class="secondary-link"
          (click)="logout()"
          >
          <mat-icon>logout</mat-icon>
          <span class="mdc-list-item__primary-text" i18n="@@Logout">Logout</span>
        </button>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="no-scrollbar content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

